import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import PubSub from "pubsub-js";
import { css } from "emotion";
import { ruler, flex, deleteItem, blockDeletion } from "./style";
import { Input, Link, DatePicker } from "@maxmilhas/hangar-components-atomic/public";
import TripTimeDropdown from "../TripTimeDropdown";

import "../../../shared/pubsub-triggers";

class OptionsRow extends Component {
    constructor(props) {
        super(props);

        this.state = { 
            outboundDate: null, 
            outboundCalendarOpen: false, 
            inboundCalendarOpen: false 
        };

        this.handlePriceChange = this.handlePriceChange.bind(this);
        this.handleRemoveRow = this.handleRemoveRow.bind(this);
    }

    handlePriceChange(event) {
        const targetPrice = parseFloat(event.target.value.replace(/[^0-9,]/g, "").replace(",", ".")).toFixed(2);
        this.props.onUpdate('targetPrice', Number(targetPrice));
    }

    handleRemoveRow(event) {
        event.preventDefault();

        if (this.props.onRemove) {
            this.props.onRemove();
        }
    }

    render() {
        const { index, canDelete, hasError: { outboundDate: outboundDateError, inboundDate: inboundDateError, targetPrice: targetPriceError } } = this.props;
        
        const { outboundCalendarOpen, inboundCalendarOpen } = this.state;

        const maxDate = moment.utc().add(329, 'days').startOf('day').toDate();

        return (
            <fieldset>
                <div className="row">
                    <div className="col-xs-16 col-sm-8 col-md-6">
                        <div className={css`${flex}`}>
                            <div className="flex-item" data-tooltip={outboundCalendarOpen ? '' : outboundDateError} data-flow="down">
                                <DatePicker
                                    id={`alerts.${index}.outboundDate`}
                                    name={`alerts.${index}.outboundDate`}
                                    label="Data da ida"
                                    shadow={true}
                                    icon="icon-calendar"
                                    hasError={outboundDateError}
                                    placeholder="__/__/____"
                                    minDate={moment.utc().add(1, 'days').startOf('day').toDate()}
                                    maxDate={maxDate}
                                    onChange={date => {
                                        this.setState({ outboundDate: date });
                                        this.props.onUpdate('outboundDate', date);
                                        
                                        PubSub.publish("dataLayer", {
                                            event: "gaEvent",
                                            gaEventCategory: "Ponte aérea max",
                                            gaEventAction: "Quais datas planeja viajar",
                                            gaEventLabel: "Interação com Data de ida",
                                            gaEventDetail: moment(date).format("DD/MM/YYYY")
                                        });
                                    }}
                                    onOpen={() => this.setState({outboundCalendarOpen: true})}
                                    onClose={() => this.setState({outboundCalendarOpen: false})}
                                    aria-required="true"
                                    aria-invalid={typeof outboundDateError === "string"}
                                    aria-label={outboundDateError || "Digite a data de ida do seu voo (apenas números) no formato dd/mm/yyyy"}
                                />
                            </div>
                            <div className="flex-item">
                                <TripTimeDropdown direction="outbound" id={`outbound-time-${index}`} onChange={data => this.props.onUpdate('outboundTime', data)} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-16 col-sm-8 col-md-6">
                        <div className={css`${flex}`}>
                            <div className="flex-item" data-tooltip={inboundCalendarOpen ? '' : inboundDateError} data-flow="down">
                                <DatePicker
                                    id={`alerts.${index}.inboundDate`}
                                    name={`alerts.${index}.inboundDate`}
                                    label="Data da volta"
                                    shadow={true}
                                    icon="icon-calendar"
                                    placeholder="__/__/____"
                                    hasError={inboundDateError}
                                    minDate={this.state.outboundDate || moment.utc().add(1, 'days').startOf('day').toDate()}
                                    maxDate={maxDate}
                                    onChange={date => {
                                        PubSub.publish("dataLayer", {
                                            event: "gaEvent",
                                            gaEventCategory: "Ponte aérea max",
                                            gaEventAction: "Quais datas planeja viajar",
                                            gaEventLabel: "Interação com Data de volta",
                                            gaEventDetail: moment(date).format("DD/MM/YYYY")
                                        });
                                    }}
                                    onClose={date => {
                                        this.props.onUpdate('inboundDate', date);
                                        this.setState({inboundCalendarOpen: false});
                                    }}
                                    onOpen={() => this.setState({inboundCalendarOpen: true})}
                                    aria-required="true"
                                    aria-invalid={typeof inboundDateError === "string"}
                                    aria-label={inboundDateError || "Digite a data de volta do seu voo (apenas números) no formato dd/mm/yyyy"}
                                />
                            </div>
                            <div className="flex-item">
                                <TripTimeDropdown direction="inbound" id={`inbound-time-${index}`} onChange={data => this.props.onUpdate('inboundTime', data)} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-16 col-md-4" data-tooltip={targetPriceError} data-flow="down">
                        <Input
                            id={`alerts.${index}.targetPrice`}
                            name={`alerts.${index}.targetPrice`}
                            label="Valor desejado"
                            type="currency"
                            shadow={true}
                            hasError={targetPriceError}
                            onChange={this.handlePriceChange}
                            data-action="maxairbridge-form-targert-price"
                            aria-required="true"
                            aria-invalid={typeof targetPriceError === "string"}
                            aria-label={targetPriceError || "Informe o valor desejado"}
                        />
                    </div>
                </div>
                {canDelete ? (
                    <Link className={css`${deleteItem}`} onClick={this.handleRemoveRow} tabIndex="0">Excluir</Link>
                ) : (
                        <p className={css`${blockDeletion}`}>Excluir</p>
                    )}
                <hr className={css`${ruler}`} />
            </fieldset>
        );
    }
}

OptionsRow.propsType = {
    index: PropTypes.number,
    onUpdate: PropTypes.func,
    onRemove: PropTypes.func,
    canDelete: PropTypes.bool,
    hasError: PropTypes.shape({
        outboundDate: PropTypes.bool,
        inboundDate: PropTypes.bool,
        targetPrice: PropTypes.bool,
    }),
};

export default OptionsRow;